import axios from "axios";

const API = axios.create({
  baseURL: "https://server-deploy-seven.vercel.app/api", // your backend base URL
});

export default API;
